// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wxfemale[data-v-6a617686] {\n  width: 100%;\n  background-color: #f5f5f5;\n}\n.wxfemale .content[data-v-6a617686] {\n    margin: -55px 45px 45px 45px;\n}\n.wxfemale .tip[data-v-6a617686] {\n    width: 100%;\n    text-align: center;\n    font-family: MicrosoftYaHei;\n    font-size: 36px;\n    color: #cccccc;\n    padding: 42px 0;\n}\n", ""]);
// Exports
module.exports = exports;
